"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkUpdateAssetsResponseToJSON = exports.BulkUpdateAssetsResponseFromJSONTyped = exports.BulkUpdateAssetsResponseFromJSON = exports.instanceOfBulkUpdateAssetsResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the BulkUpdateAssetsResponse interface.
 */
function instanceOfBulkUpdateAssetsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfBulkUpdateAssetsResponse = instanceOfBulkUpdateAssetsResponse;
function BulkUpdateAssetsResponseFromJSON(json) {
    return BulkUpdateAssetsResponseFromJSONTyped(json, false);
}
exports.BulkUpdateAssetsResponseFromJSON = BulkUpdateAssetsResponseFromJSON;
function BulkUpdateAssetsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'failedIds': !(0, runtime_1.exists)(json, 'failed_ids') ? undefined : json['failed_ids'],
        'successfulIds': !(0, runtime_1.exists)(json, 'successful_ids') ? undefined : json['successful_ids'],
    };
}
exports.BulkUpdateAssetsResponseFromJSONTyped = BulkUpdateAssetsResponseFromJSONTyped;
function BulkUpdateAssetsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'failed_ids': value.failedIds === undefined ? undefined : Array.from(value.failedIds),
        'successful_ids': value.successfulIds === undefined ? undefined : Array.from(value.successfulIds),
    };
}
exports.BulkUpdateAssetsResponseToJSON = BulkUpdateAssetsResponseToJSON;
